import { useState, useEffect } from 'react';

const ChartSVG = () => {
  const [offsetLightGreen, setOffsetLightGreen] = useState(0);
  const [offsetDarkGreen, setOffsetDarkGreen] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setOffsetLightGreen(prev => (prev + 0.5) % 300);
      setOffsetDarkGreen(prev => (prev + 0.1) % 300);
    }, 50); 
    return () => clearInterval(interval);
  }, []);

  const wave = (amplitude, frequency, phase, baseHeight, offset) => {
    let path = '';
    for (let x = 0; x <= 300; x += 5) {
        const y = baseHeight + amplitude * Math.sin((x + phase + offset) * frequency * Math.PI / 75);
        path += `${x === 0 ? 'M' : 'L'}${x},${y} `;
    }
    path += `V100 H0 Z`;
  return path;
  };

  return (
    <div className="chart-container">
      <svg width="100%" height="100%" viewBox="0 0 300 100" preserveAspectRatio="none">
        <defs>
          {/* Onda verde claro */}
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: 'rgba(145, 213, 0, 0.35)' }} />
            <stop offset="100%" style={{ stopColor: 'rgba(145, 213, 0, 0)' }} />
          </linearGradient>

          {/* Onda verde oscuro */}
          <linearGradient id="gradient2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: 'rgba(0, 105, 57, 0.3)' }} />
            <stop offset="100%" style={{ stopColor: 'rgba(0, 105, 57, 0)' }} />
          </linearGradient>
        </defs>

        {/* Onda verde claro */}
        <path d={wave(20, 1.2, 0, 70, offsetLightGreen)} fill="url(#gradient1)" />
        <path d={wave(20, 1.2, 0, 70, offsetLightGreen).replace('V100 H0 Z','')} fill="none" stroke="#91D500" strokeWidth="2" />

        {/* Onda verde oscuro */}
        <path d={wave(33, 0.9, 30, 60, offsetDarkGreen)} fill="url(#gradient2)" />
        <path d={wave(33, 0.9, 30, 60, offsetDarkGreen).replace('V100 H0 Z','')} fill="none" stroke="#006939" strokeWidth="2" />
      
      </svg>
    </div>
  );
};

export default ChartSVG;
